<template>
<div class="imgOrVoiceOrVideoMaterial">
  <div
    class="list-outer-material clearfix"
  >
    <div
      v-if="isAuth('wx:wxassets:save')"
      class="card-item">
      <div class="add-card-item-inner">
        <span
          @click="addHandle"
          :style="btnStyle"
          class="icon-box">+</span>
        <el-button
          @click="addHandle"
          type="text"
          class="btn"
        >新增</el-button>
      </div>
    </div>
    <card-item
      class="card-item"
      v-for="item in listData"
      :file-type="fileType"
      :item-data="item"
      :is-select-mode="true"
      @selected="selectedHandle"
      @delete-success="deleteSuccess"
    ></card-item>
  </div>
  <div class="pagination-outer" v-if="total">
    <div class="paginnation-left">
      <size-change @sizeChange="sizeChange"></size-change>
      <span class="tatol-count">合计 {{total}} 条</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
  <add-material-img-or-thumb-dialog
    :dialog-show="addImageDialogShow"
    @close="closeAddImageDialogShow"
    @add-success="addImgSuccess"
  ></add-material-img-or-thumb-dialog>
  <add-voice-dialog
    :file-type="fileType"
    :dialog-show="addVoiceDialogShow"
    @close="closeAddVoiceDialogShow"
    @add-success="addVoiceSuccess"
  ></add-voice-dialog>
</div>
</template>

<script>
import addVoiceDialog from "../../../../components/wx/material/material/addVoiceDialog";
import addMaterialImgOrThumbDialog from '@/components/wx/material/material/addMaterialImgOrThumbDialog'
import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
import cardItem from "@/components/wx/material/cardItem";
import initData from "@/mixins/initData";
export default {
  name: "imgOrVoiceOrVideoMaterial",
  components:{
    cardItem,
    addMaterialImgOrThumbDialog,
    addVoiceDialog,
  },
  props: {
    isSelectMode:{
      type: Boolean,
      default: false,
    },
    fileType: {//image,voice, video
      type: String,
      default: 'image'
    },
  },
  mixins: [initData],
  data() {
    return {
      size: 20,
      addImageDialogShow: false,
      addVoiceDialogShow: false,
      addVideoDialogShow: false,
    }
  },
  watch:{
    fileType(val){
      if(val == 'imgText') return;
      this.searchHandle();
    },
    selectedAppid(val){
      if(val){
        this.searchHandle();
      }
    },
  },
  computed: {
    ...mapGetters(['themeColor','selectedAppid']),
    btnStyle(){
      return {
        backgroundColor: colorRgba(this.themeColor,0.5),
      }
    }
  },
  created(){
    this.searchHandle();
  },
  methods: {
    beforeInit(){
      this.url = '/wx/manage/wxAssets/materialFileBatchGet';
      this.params = {
        page: this.page,
        limit: this.size,
        'type': this.fileType
      }
      return true;
    },
    selectedHandle(itemData){
      this.$emit('selected', itemData);
    },
    addHandle(){
      setTimeout(() => {
        if(this.fileType == 'image'){
          this.addImageDialogShow = true;
        }else if(this.fileType == 'voice' || this.fileType == 'video'){
          this.addVoiceDialogShow = true;
        }
      },200);
    },
    closeAddImageDialogShow(){
      this.addImageDialogShow = false;
    },
    addImgSuccess(){
      this.addImageDialogShow = false;
      this.searchHandle();
    },
    closeAddVoiceDialogShow(){
      setTimeout(() => {
        this.addVoiceDialogShow = false;
      },200);
    },
    addVoiceSuccess(){
      this.addVoiceDialogShow = false;
      this.searchHandle();
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    getListData(){
      this.$http({
        url: '/wx/manage/wxAssets/materialFileBatchGet',
        method: 'get',
        params: {
          page: this.page,
          limit: this.size,
          'type': this.fileType
        }
      }).then((res) => {
        if (res && res.code === 200) {
          let loadCount = 0;
          for (let i = 0; i < res.data.items.length; i++) {

            let image = new Image()
            image.src = res.data.items[i].url;
            image.onload = () => {
              loadCount++;
              //判断是否结束
              if (loadCount >= res.data.items.length) {
                //loading end
                this.listData = res.data.items;
              }
            }
          }

        }
      })
    },
    deleteSuccess(){
      this.searchHandle();
    }
  },
}
</script>

<style lang="scss">
@import "../../../../assets/scss/variable";
.imgOrVoiceOrVideoMaterial {
  .list-outer-material {
    display: flex;
    flex-wrap: wrap;
    .card-item {
      width: 170px;
      .add-card-item-inner {
        height: 261px;
        border: 1px solid #E0E4F2;
        border-radius: 10px;
        overflow: hidden;
      }
      .card-preview {
        line-height: 170px;
        max-height: 170px;
      }
    }
    .card-preview-text {
      font-size: 11px;
    }
  }
}
</style>
